import dayjs from 'dayjs';
import parser from 'dayjs/plugin/customParseFormat';
import formatter from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/pt-br';

import { depatternize } from '@formatters/patternize';

dayjs.extend(parser);
dayjs.extend(formatter);
dayjs.locale('pt-br');

function values(value, options) {
  const items = [value];
  const label = options?.find?.((o) => String(o.value) === value)?.label;

  if (label) {
    items.push(label);
  }

  return items;
}

const RULES = {
  equal: function equal(value, rule, options) {
    return values(value, options).includes(rule.value);
  },

  greaterThan: function greaterThan(value, rule) {
    return depatternize(value) > rule.count;
  },

  included: function included(value, rule, options) {
    return values(value, options)
      .some((i) => (rule.values || rule.value)
        .map((j) => String(j))
        .includes(i));
  },

  not_included: function notIncluded(value, rule, options) {
    return !RULES.included(value, rule, options);
  },

  lessThan: function lessThan(value, rule) {
    return depatternize(value) < rule.count;
  },

  notEqual: function notEqual(value, rule, options) {
    return !RULES.equal(value, rule, options);
  },

  olderThan: function olderThan(value, rule) {
    const v = dayjs(value, /-/.test(value) ? 'YYYY-MM-DD' : 'DD/MM/YYYY');

    return v.isBefore(dayjs().subtract(rule.count, 'ms'));
  },

  soonerThan: function soonerThan(value, rule) {
    const v = dayjs(value, /-/.test(value) ? 'YYYY-MM-DD' : 'DD/MM/YYYY');

    return v.isAfter(dayjs().subtract(rule.count, 'ms'));
  },

  required: function required(value, rule) {
    if (!rule.field) {
      return true;
    }

    return !!value;
  },

  visible: function visible() {
    return true;
  },
};

Object.keys(RULES).forEach((rule) => {
  const cammel = rule.replace(/[A-Z]/g, (word) => `_${word}`).toLowerCase();

  if (RULES[cammel]) {
    return;
  }

  RULES[cammel] = RULES[rule];
});

export default RULES;
